(function () {
  'use strict';

  var PROXY_BASE = '';
  var section, form, input, submitBtn, errorBox, vehicleSection,
      vehicleGrid, vehicleExtra, loadingIndicator, resultsSection,
      resultsContainer, categoryNav, noResults;

  var activeCategory = 'all';

  function init() {
    section = document.querySelector('[data-np-section]');
    if (!section) return;

    PROXY_BASE = section.dataset.proxyUrl || '';

    form            = section.querySelector('[data-np-form]');
    input           = section.querySelector('[data-np-input]');
    submitBtn       = section.querySelector('[data-np-submit]');
    errorBox        = section.querySelector('[data-np-error]');
    vehicleSection  = section.querySelector('[data-np-vehicle]');
    vehicleGrid     = section.querySelector('[data-np-vehicle-grid]');
    vehicleExtra    = section.querySelector('[data-np-vehicle-extra]');
    loadingIndicator = section.querySelector('[data-np-loading]');
    resultsSection  = section.querySelector('[data-np-results]');
    resultsContainer = section.querySelector('[data-np-results-container]');
    categoryNav     = section.querySelector('[data-np-category-nav]');
    noResults       = section.querySelector('[data-np-no-results]');

    if (form) form.addEventListener('submit', onSubmit);

    var urlPlate = new URLSearchParams(window.location.search).get('plate');
    if (urlPlate) {
      input.value = urlPlate.toUpperCase();
      doLookup(urlPlate);
    }
  }

  // ── Data helpers ──────────────────────────────────────────────────────────

  function getManualMappings() {
    try {
      var el = document.getElementById('np-manual-map');
      if (!el) return [];
      var entries = JSON.parse(el.textContent);
      return Array.isArray(entries) ? entries : [];
    } catch (e) { return []; }
  }

  function getPrerenderedCard(handle) {
    var container = document.getElementById('np-prerendered-cards');
    if (!container) return null;
    var el = container.querySelector('[data-np-card-handle="' + handle + '"]');
    return el ? el.innerHTML : null;
  }

  function getPrerenderedCollection(handle) {
    var container = document.getElementById('np-prerendered-collections');
    if (!container) return null;
    var el = container.querySelector('[data-np-coll-handle="' + handle + '"]');
    return el ? el.innerHTML : null;
  }

  // ── Event handlers ────────────────────────────────────────────────────────

  function onSubmit(e) {
    e.preventDefault();
    var plate = (input.value || '').trim().toUpperCase().replace(/\s+/g, '');
    if (!plate || plate.length < 2) {
      showError('Indtast venligst en gyldig nummerplade.');
      return;
    }
    var url = new URL(window.location);
    url.searchParams.set('plate', plate);
    window.history.replaceState({}, '', url);
    doLookup(plate);
  }

  function doLookup(plate) {
    plate = plate.toUpperCase().replace(/\s+/g, '');
    resetResults();
    setLoading(true);

    fetch(PROXY_BASE + '/api/lookup?plate=' + encodeURIComponent(plate))
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw new Error(d.error || 'Opslag fejlede.'); });
        return res.json();
      })
      .then(function (data) {
        setLoading(false);
        var ktypNo = data.vehicle ? String(data.vehicle.KtypNo) : null;
        if (data.vehicle) showVehicleInfo(data.vehicle);

        var matched = data.matched || {};
        var hasApiMatched = Object.keys(matched).some(function (cat) { return matched[cat].length > 0; });

        // ── Match metaobject entries ────────────────────────────────────────
        var manualEntries = getManualMappings();
        var ktypProducts    = [];
        var ktypCollections = [];

        if (ktypNo) {
          manualEntries.forEach(function (entry) {
            // Support both old format {ktyp, handle} and new format {ktyps[], handles[], collections[]}
            var ktyps = entry.ktyps || (entry.ktyp ? [entry.ktyp] : []);
            var matches = ktyps.some(function (k) { return String(k).trim() === ktypNo; });
            if (!matches) return;

            var kat = (entry.kategori || '').trim() || 'Anbefalet til din bil';

            // Products — new format uses handles[], old format uses handle (single)
            var handles = entry.handles || (entry.handle ? [entry.handle] : []);
            handles.forEach(function (handle) {
              if (handle) ktypProducts.push({ handle: handle, _kategori: kat });
            });

            // Collections — new field
            (entry.collections || []).forEach(function (collHandle) {
              if (collHandle) ktypCollections.push({ handle: collHandle, _kategori: kat });
            });
          });
        }

        if (hasApiMatched || ktypProducts.length > 0 || ktypCollections.length > 0) {
          displayResults(matched, ktypProducts, ktypCollections);
        } else {
          show(noResults);
        }
      })
      .catch(function (err) {
        setLoading(false);
        showError(err.message || 'Der opstod en fejl. Prøv igen senere.');
      });
  }

  // ── Display ───────────────────────────────────────────────────────────────

  function showVehicleInfo(v) {
    if (!vehicleSection) return;

    var fuelMap = { '1': 'Benzin', '2': 'Diesel', '3': 'El', '4': 'Hybrid' };

    var cells = [];
    if (v.Make)       cells.push({ label: 'Mærke',      value: v.Make });
    if (v.Model)      cells.push({ label: 'Model',      value: v.Model });
    if (v.Type)       cells.push({ label: 'Type/Motor', value: v.Type });
    if (v.FirstRegDate) cells.push({ label: 'Årgang',   value: v.FirstRegDate.substring(0, 4) });
    if (v.MotorCode || v.EngineCode) cells.push({ label: 'Motorkode', value: v.MotorCode || v.EngineCode });
    if (v.Drivmiddel) cells.push({ label: 'Drivmiddel', value: fuelMap[v.Drivmiddel] || v.Drivmiddel });

    vehicleGrid.innerHTML = cells.map(function (c) {
      return '<div class="np-vg-cell"><div class="np-vg-label">' + esc(c.label) +
             '</div><div class="np-vg-value">' + esc(c.value) + '</div></div>';
    }).join('');

    var extras = [];
    if (v.FirstRegDate) {
      var d      = v.FirstRegDate;
      var months = ['januar','februar','marts','april','maj','juni','juli','august','september','oktober','november','december'];
      var parts  = d.split('-');
      if (parts.length === 3) {
        var day   = parseInt(parts[2], 10);
        var month = parseInt(parts[1], 10);
        var year  = parts[0];
        if (month >= 1 && month <= 12 && day) {
          extras.push('<span>Første registrering: ' + day + '. ' + months[month - 1] + ' ' + year + '</span>');
        }
      }
    }
    if (v.KtypNo) {
      extras.push('<span class="np-ktyp-tag">KtypNo: <strong>' + esc(String(v.KtypNo)) + '</strong></span>');
    }
    vehicleExtra.innerHTML = extras.join('');
    show(vehicleSection);
  }

  function displayResults(matched, ktypProducts, ktypCollections) {
    var grouped = {};

    // API-matched products
    Object.keys(matched).forEach(function (cat) {
      if (!grouped[cat]) grouped[cat] = [];
      matched[cat].forEach(function (product) {
        grouped[cat].push({ _type: 'api', _card: product });
      });
    });

    // Metaobject-matched products
    ktypProducts.forEach(function (p) {
      var cat = p._kategori || 'Anbefalet til din bil';
      if (!grouped[cat]) grouped[cat] = [];
      grouped[cat].push({ _type: 'product', _card: p });
    });

    // Metaobject-matched collections
    ktypCollections.forEach(function (c) {
      var cat = c._kategori || 'Anbefalet til din bil';
      if (!grouped[cat]) grouped[cat] = [];
      grouped[cat].push({ _type: 'collection', _card: c });
    });

    // De-duplicate by handle within each category
    Object.keys(grouped).forEach(function (cat) {
      var seen = {};
      grouped[cat] = grouped[cat].filter(function (item) {
        var h = item._card.handle;
        if (!h) return true;
        if (seen[h]) return false;
        seen[h] = true;
        return true;
      });
    });

    var catKeys = Object.keys(grouped).sort();
    var total   = catKeys.reduce(function (sum, cat) { return sum + grouped[cat].length; }, 0);

    if (total === 0) { show(noResults); return; }

    // Category navigation (only when multiple categories)
    if (catKeys.length > 1) {
      categoryNav.innerHTML = catKeys.map(function (cat) {
        return '<button class="np-cat-btn" data-category="' + esc(cat) + '">' + esc(cat) + '</button>';
      }).join('');
      categoryNav.querySelectorAll('.np-cat-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          activeCategory = this.dataset.category;
          categoryNav.querySelectorAll('.np-cat-btn').forEach(function (b) { b.classList.remove('is-active'); });
          this.classList.add('is-active');
          resultsContainer.querySelectorAll('.np-cat-group').forEach(function (g) {
            g.style.display = g.dataset.category === activeCategory ? '' : 'none';
          });
          scrollToResults();
        });
      });
    }

    var html = '';
    catKeys.forEach(function (cat) {
      html += '<div class="np-cat-group" data-category="' + esc(cat) + '">';
      html += '<h3 class="np-cat-group__title">' + esc(cat) + '</h3>';
      html += '<div class="collection">';
      html += '<ul class="product-grid grid grid--2-col grid--3-col-tablet grid--4-col-desktop" role="list">';

      grouped[cat].forEach(function (item) {
        if (item._type === 'collection') {
          var prerendered = getPrerenderedCollection(item._card.handle);
          if (prerendered) {
            html += prerendered;
          }
        } else if (item._type === 'product') {
          var prerendered = getPrerenderedCard(item._card.handle);
          if (prerendered) {
            html += prerendered;
          }
        } else {
          // API result — try prerendered first, fall back to JS render
          var pre = getPrerenderedCard(item._card.handle);
          if (pre) {
            html += pre;
          } else {
            html += '<li class="grid__item">' + renderCard(item._card) + '</li>';
          }
        }
      });

      html += '</ul></div></div>';
    });

    resultsContainer.innerHTML = html;
    show(resultsSection);
    scrollToResults();
  }

  function renderCard(p) {
    var price    = p.price ? formatMoney(p.price) : '';
    var cmpPrice = p.compare_at_price ? formatMoney(p.compare_at_price) : '';
    var onSale   = cmpPrice && parseFloat(p.compare_at_price) > parseFloat(p.price);

    var priceHtml = '';
    if (price) {
      priceHtml = '<div class="price' + (onSale ? ' price--on-sale' : '') + '">' +
        '<dl>' +
          '<div class="price__regular">' +
            '<dt><span class="visually-hidden">Normalpris</span></dt>' +
            '<dd><span class="price-item price-item--regular">' + price + '</span></dd>' +
          '</div>' +
          '<div class="price__sale">' +
            '<dt class="price__compare"><span class="visually-hidden">Normalpris</span></dt>' +
            '<dd class="price__compare"><s class="price-item price-item--regular">' + cmpPrice + '</s></dd>' +
            '<dt><span class="visually-hidden">Udsalgspris</span></dt>' +
            '<dd><span class="price-item price-item--sale">' + price + '</span></dd>' +
          '</div>' +
        '</dl>' +
      '</div>';
    }

    var imgHtml    = p.image ? '<picture class="motion-reduce"><img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy"></picture>' : '';
    var vendorHtml = p.vendor ? '<div class="card-information__top"><div class="card-article-info caption-with-letter-spacing">' + esc(p.vendor) + '</div></div>' : '';
    var buttonHtml = p.available === false
      ? '<button class="button button--small button--soldout" type="button" disabled="disabled">Udsolgt</button>'
      : '<a href="' + esc(p.url) + '" class="button button--small" tabindex="-1">G\u00e5 til produkt</a>';

    return '<div class="card-wrapper pro-card-wrapper">' +
      '<div class="card card--product" tabindex="-1">' +
        '<a href="' + esc(p.url) + '" class="card__media media-wrapper" tabindex="-1">' +
          '<div class="image-animate media media--square media--hover-effect">' + imgHtml + '</div>' +
        '</a>' +
      '</div>' +
      '<div class="card-information">' +
        '<a href="' + esc(p.url) + '" class="full-unstyled-link"><span class="visually-hidden">' + esc(p.title) + '</span></a>' +
        '<div class="card-information__wrapper">' +
          vendorHtml +
          '<a href="' + esc(p.url) + '" class="card-information__text h4" tabindex="-1">' + esc(p.title) + '</a>' +
          priceHtml +
          (p.body ? '<div class="product_short"><p>' + esc(p.body) + '</p></div>' : '') +
        '</div>' +
      '</div>' +
      '<div class="card-information__button">' + buttonHtml + '</div>' +
    '</div>';
  }

  // ── Utilities ─────────────────────────────────────────────────────────────

  function scrollToResults() {
    if (vehicleSection) vehicleSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function showError(msg) {
    if (!errorBox) return;
    errorBox.textContent = msg;
    errorBox.classList.add('is-visible');
  }

  function show(el) { if (el) el.classList.add('is-visible'); }
  function hide(el) { if (el) el.classList.remove('is-visible'); }

  function resetResults() {
    activeCategory = 'all';
    hide(vehicleSection);
    hide(errorBox);
    hide(resultsSection);
    hide(noResults);
    hide(loadingIndicator);
    if (categoryNav)      categoryNav.innerHTML = '';
    if (resultsContainer) resultsContainer.innerHTML = '';
    if (vehicleGrid)      vehicleGrid.innerHTML = '';
    if (vehicleExtra)     vehicleExtra.innerHTML = '';
  }

  function setLoading(loading) {
    if (submitBtn)        submitBtn.classList.toggle('is-loading', loading);
    if (loadingIndicator) loadingIndicator.classList.toggle('is-visible', loading);
  }

  function formatMoney(price) {
    var num = parseFloat(price);
    if (isNaN(num)) return '';
    var parts = num.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts.join(',') + ' DKK';
  }

  function esc(str) {
    if (!str) return '';
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(str));
    return d.innerHTML;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
